import { LoadingView } from 'components';
import { SigningContract } from 'modules/onboarding/common/components';
import { SigningDocumentsFormType } from 'modules/onboarding/common/forms/signingDocumentsForm';
import { useClientSigningContract } from 'modules/onboarding/common/hooks';

import { useOnboardingContext } from '../hooks/useOnboardingContext';

export const SigningContractStep = () => {
  const { data, goToNext } = useOnboardingContext();

  const {
    onClickDocument,
    onSubmit,
    formError,
    loading,
    documents,
    submitLoading,
  } = useClientSigningContract(data);

  const handlerSubmit = async (values: SigningDocumentsFormType) => {
    if (values) {
      await onSubmit(values);
      goToNext();
    }
  };

  if (loading || !documents) {
    return <LoadingView />;
  }

  return (
    <SigningContract
      documents={documents}
      formError={formError}
      submitLoading={submitLoading}
      onClickDocument={onClickDocument}
      onSubmit={handlerSubmit}
    />
  );
};
